import { McpLogo } from '@/shared/ui';

import {
  SectionPageHeader,
  SectionPageHeaderContent,
  SectionPageHeaderDescription,
  SectionPageHeaderIcon,
  SectionPageHeaderTitle,
} from '@/shared/ui/layout/SectionPageHeader/SectionPageHeader';
import { ListPageBody } from '@/shared/ui/layout/ListPageLayout/ListPageLayout';
import { McpMarketplace } from '@/features/user-mcp-servers';
import { useTranslation } from 'react-i18next';

export const MyMcpsPage = () => {
  const { t } = useTranslation('admin');
  return (
    <div className="w-full h-full overflow-y-auto bg-surface">
      <div className="flex flex-col w-full gap-4 p-4">
        <SectionPageHeader>
          <SectionPageHeaderIcon>
            <McpLogo size={24} />
          </SectionPageHeaderIcon>
          <SectionPageHeaderContent>
            <SectionPageHeaderTitle>{t('myMcps.myMcpsPage.myMcps')}</SectionPageHeaderTitle>
            <SectionPageHeaderDescription>
              {t('myMcps.myMcpsPage.installMcpServersFromYour')}
            </SectionPageHeaderDescription>
          </SectionPageHeaderContent>
        </SectionPageHeader>
        <ListPageBody className="p-6">
          <McpMarketplace />
        </ListPageBody>
      </div>
    </div>
  );
};
